export const objectIsValid = obj => 
    Object.keys(obj).length !== 0 && 
    (typeof obj.number !== 'undefined' && 
    obj.number !== '' || typeof obj.name !== 'undefined' && 
obj.name !== '');
